import * as React from 'react';
import { FC } from 'react';
import { JackpotAggregatorCampaignProps } from './types';
import Jackpot from './Jackpot';
import Rules from './Rules';
import Leaderboards from './Leaderboards';
import { LocalesContext } from './locales';

const JackpotAggregatorCampaign: FC<JackpotAggregatorCampaignProps> = (props) => (
  <LocalesContext.Provider value={props.locales}>
    <div className="jackpot_widget j-w">
      <div className="j-w_range jw-range">
        <ul className="jw-range_list" aria-label="range-list">
          {props.jackpots.map((j) => (
            <Jackpot key={j.name} jackpot={j} currency={props.currency} />
          ))}
        </ul>
      </div>
      <Rules {...props} />
      <Leaderboards {...props} />
    </div>
  </LocalesContext.Provider>
);

const WrappedLottery: FC<JackpotAggregatorCampaignProps> = (props) => <JackpotAggregatorCampaign {...props} />;

export default WrappedLottery;
